/**
 * O bot da VibX sai do ambiente, e não do código: cada dev tem o seu (`vib_dev_1_bot`, etc.), e o
 * link cravado mandava quem cadastrava comunidade no local conversar com o bot de PRODUÇÃO — que
 * responde, vincula a conta errada e não sabe nada do rascunho local.
 *
 * Mesma variável que o `VerifyUserWidget` já lia, e mesmo default de produção: `env-validation.js`
 * a exige, então o fallback só cobre contexto sem env carregado (jest).
 */
const TELEGRAM_VIB_BOT =
  process.env.NEXT_PUBLIC_TELEGRAM_VIB_BOT || 'vib_telegram_bot';

export const vibxConstants = {
  SUPPORT_WHATSAPP: 'https://wa.me/553183519296',
  SUPPORT_TELEGRAM: 'https://t.me/atendimentovibx3bot',
  INDICTMENT_LINK: 'https://app.vibx.com.br/indictment',
  SUPPORT_EMAIL: 'contato@vibx.com.br',
  INSTAGRAM_LINK: 'https://www.instagram.com/vibx.oficial',
  VIB_BOT_URL: `https://t.me/${TELEGRAM_VIB_BOT}`,
};

/**
 * Valores das novas taxas cobradas por transação, exibidos no aviso de
 * atualização de taxas (@components/FeeChangeBanner).
 * Ao alterar os valores, atualize também o LOCAL_STORAGE_KEY em
 * @repository/feeChangeNotice para que o aviso volte a aparecer.
 */
export const feeChangeNotice = {
  START_DATE: '04/08',
  PERCENTAGE_FEE: '8%',
  FIXED_FEE: 'R$ 1,00',
};

export const SUPPORT_WHATSAPP_NUMBER =
  '+' + vibxConstants.SUPPORT_WHATSAPP.split('/').pop();
export const SUPPORT_TELEGRAM_USERNAME =
  vibxConstants.SUPPORT_TELEGRAM.split('/').pop();
